import { ajaxSend } from 'api/api';
export function getAllNotifications() {
    return ajaxSend({
        path: '/v1/notifications',
    });
}
export function getUnreadNotifications() {
    return ajaxSend({
        path: '/v1/notifications',
        params: {
            unread: true,
        },
    });
}
export function getNotificationById(notificationId) {
    return ajaxSend({
        path: `/v1/notifications/${notificationId}`,
    });
}
export function markNotificationAsRead(notificationIds) {
    return ajaxSend({
        path: '/v1/notifications/read',
        method: 'PUT',
        data: {
            notification_ids: notificationIds,
        },
    });
}
